// extracted by mini-css-extract-plugin
module.exports = {"label":"FormSelect_label___hYlz","isDisabled":"FormSelect_isDisabled__TCw40"};